import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneComunali2025 extends Component {
  render() {
    let { regione} = this.props.params;
    let repoDettaglio2025 = "/elezioni/withub/electionday-2025/comunali-ballottaggio/" + regione + "/" + regione + ".html";
    let repoFascione2025 = "/elezioni/withub/electionday-2025/comunali-ballottaggio/fascione-composto.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio2025} />
        <EWH id="ewh-fascione" repo={repoFascione2025} />
    </div>
    )
  }
}

export default withParams(RegioneComunali2025)
